import { render, staticRenderFns } from "./Genealogy.vue?vue&type=template&id=773420e2&"
import script from "./Genealogy.vue?vue&type=script&lang=js&"
export * from "./Genealogy.vue?vue&type=script&lang=js&"
import style0 from "./Genealogy.vue?vue&type=style&index=0&id=773420e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports